// extracted by mini-css-extract-plugin
module.exports = {"Nav":"menu_Nav__X1M0_","NavBaltex":"menu_NavBaltex__QIpza","Selected":"menu_Selected__4Ft_K"};